/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $InternalServerError = {
  properties: {
    message: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
